import CartModal from "common/order/CartModal";
import { RiWallet3Line } from "react-icons/ri";
import { IoExitOutline } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import useWindowSize from "hooks/useWindowSize.jsx";

import { NavLink } from "react-router-dom";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext, useEffect } from "react";
import { useState } from "react";
// import logo from "assets/images/sitelogo.svg";
import { HiUser } from "react-icons/hi";
import CardItemsContext from "context/cardItems";
import { IoSearchOutline, IoEnterOutline } from "react-icons/io5";
import logo from "assets/images/Logos/GRC_Logo-removebg-preview.png";

export default function MenuMobile({
  isOpen,
  publicLink,
  privateLink,
  setIsOpen,
  mainShopAdmin,
  pic,
  inventoryWallets,
  setInvenoryWallets,
  findWallet,
  click,
  setClick,
}) {
  let UrlTitle = useLocation();
  const { width } = useWindowSize();
  useEffect(() => {
    switch (UrlTitle.pathname) {
      case "/":
        setClick(1);
        break;
      case "/store":
        setClick(2);
        break;
      case "/blog":
        setClick(3);
        break;
      case "/admin-panel/dashboard":
        setClick(4);
        break;
      case "/admin-panel/orders":
        setClick(5);
        break;
      case "/admin-panel/financial":
        setClick(6);
        break;
      case "/admin-panel/user_management":
        setClick(7);
        break;
      case "customer-panel/profile":
        setClick(8);
        break;
      case "/customer-panel/orders":
        setClick(9);
      case "/customer-panel/messages":
        setClick(10);
        break;

      default:
        setClick(1);
    }
    // if (width && width > 992 && isOpen === false) {
    //   setIsOpen(true);
    // }
    // if (width && width < 992 && isOpen === true) {
    //   setIsOpen(false);
    // }
    console.log("urlTitle", UrlTitle);
  }, [width, click, UrlTitle]);
  const auth = useContext(WithAuthentication);
  const [selectedItem, setSelectedItem] = useState(-1);
  const { items, setItems, editCartItems, updateCartItemsFunc, length } =
    useContext(CardItemsContext);
  return (
    <div>
      {isOpen && (
        <div className="menu-mobile shadow pb-5">
          <div className="text-end">
            <AiOutlineClose
              className="me-1 mt-1"
              style={{ width: 20, height: 20 }}
              onClick={() => {
                setIsOpen(false);
              }}
            />
          </div>

          <div className="text-center my-2">
            {auth.userInfo.userType == 0 ? (
              <div className="mt-2">
                <img src={logo} alt="logo" />

                <div className="mt-3">مدیر محترم به GRC خوش آمدید</div>
              </div>
            ) : (
              <div className="mt-2">
                {/* <HiUser style={{ width: 80, height: 80 }} /> */}

                {pic == undefined || pic == "" ? (
                  <HiUser style={{ width: 80, height: 80 }} />
                ) : (
                  <img
                    className="rounded-pill"
                    src={`http://grc.tatdemo.ir/${pic}`}
                    style={{ width: 80, height: 80 }}
                  />
                )}
                <div className="mt-3">
                  {auth.userInfo.userType == 1
                    ? auth.userInfo.fullName != ""
                      ? `${auth.userInfo.fullName} `
                      : "کاربر عزیز"
                    : auth.userInfo.userType == 0
                    ? "مدیر محترم  "
                    : auth.userInfo.userType == -1 && "کاربر عزیز"}
                  &nbsp;به GRC خوش آمدید.
                </div>
              </div>
            )}
          </div>

          <div className="position-relative ul-container mt-3  my-2">
            {!mainShopAdmin && auth.isLogged && (
              <div className="left-side1 nav-item">
                <div className="nav-link">
                  <CartModal
                    inventoryWallets={inventoryWallets}
                    setInvenoryWallets={setInvenoryWallets}
                    findWallet={findWallet}
                    className=" li"
                  />
                </div>
              </div>
            )}

            {/* <div
              className="nav-item left-side1 li"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <div
                className="nav-link "
                
              >
                <CartModal></CartModal>
               
              </div>
            </div> */}
            {/* <li>
              <NavLink to="/">
                <div className="nav-link text-dark size1">
                  <span style={{ fontSize: 14 }} className="mx-1 ">
                    کیف پول شما
                  </span>
                  
                  <RiWallet3Line style={{ fontSize: "18px" }}></RiWallet3Line>
                </div>
              </NavLink>
            </li> */}
            {/* public links */}
            {publicLink.map((pl) => {
              if (pl.type == "modal") {
                return (
                  <div
                    className={`li ${selectedItem == pl.id && "active-item"}`}
                    data-bs-target={`${pl.target}`}
                    data-bs-toggle="modal"
                    onClick={() => {
                      setIsOpen(false);
                      setSelectedItem(pl.id);
                    }}
                  >
                    {pl.name}
                  </div>
                );
              } else if (pl.id != 2) {
                return (
                  <NavLink
                    to={`${pl.href}`}
                    className={`li ${click == pl.click && "active-item"}`}
                    onClick={() => {
                      setIsOpen(false);
                      setSelectedItem(pl.id);
                      setClick(pl.click);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      {pl.icon} {pl.name}
                    </div>
                  </NavLink>
                );
              } else if (pl.id == 2) {
                return (
                  <NavLink
                    to={`${pl.href}`}
                    className={`li ${click == pl.click && "active-item"}`}
                    onClick={() => {
                      setIsOpen(false);
                      setSelectedItem(pl.id);
                      setClick(pl.click);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      {pl.icon} {pl.name}
                    </div>
                  </NavLink>
                );
              }
            })}

            {auth.userInfo.userType == 0 ? (
              <div className="mt-3 mb-2  rounded py-1 text-center panel-title">
                پنل ادمین
              </div>
            ) : (
              auth.userInfo.userType == 1 && (
                <div className="mt-3 mb-2  rounded py-1 text-center panel-title">
                  پنل کاربر
                </div>
              )
            )}
            {/* user panel links */}
            {privateLink.map((vl) => {
              if (vl.type == "modal") {
                return (
                  <div
                    className={`li ${
                      click == vl.click &&
                      vl.id != 11 &&
                      vl.id != -2 &&
                      "active-item"
                    }`}
                    data-bs-target={`${vl.target}`}
                    data-bs-toggle="modal"
                    onClick={() => {
                      setIsOpen(false);
                      setSelectedItem(vl.id);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      {" "}
                      {vl.icon} {vl.name}
                    </div>
                  </div>
                );
              } else {
                return (
                  <NavLink
                    to={`${vl.link}`}
                    className={`li ${
                      click == vl.click &&
                      vl.id != 11 &&
                      vl.id != -2 &&
                      "active-item"
                    }`}
                    onClick={() => {
                      setIsOpen(false);
                      setSelectedItem(vl.id);
                      setClick(vl.click);
                    }}
                  >
                    <div className="d-flex align-items-center">
                      {vl.icon}
                      {vl.name}
                    </div>
                  </NavLink>
                );
              }
            })}
            {/* exit button */}
            <div className="">
              {auth.isLogged && (
                // (
                //   <div
                //     className=" size1 text-decoration-none text-dark  text-center mt-2"
                //     style={{ cursor: "pointer", marginRight: "auto" }}
                //     data-bs-toggle="modal"
                //     data-bs-target="#ModalNumber"
                //   >
                //     <div className="d-flex align-items-center">
                //       <IoEnterOutline></IoEnterOutline>
                //       ورود
                //     </div>
                //   </div>
                // ) :
                <div className="inter-btn">
                  <NavLink
                    className="size1 text-decoration-none text-dark  text-center mt-2"
                    to={`/`}
                    // className={`li ${selectedItem == pl.id && "active-item"}`}
                    onClick={() => {
                      auth.logout();
                      setIsOpen(false);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center ">
                      <IoExitOutline></IoExitOutline> خروج
                    </div>
                  </NavLink>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
